import{BeanContestationAnswer} from './BeanContestationAnswer'
import { BeanUsuario } from './BeanUsuario';

export class BeanContestation{
    constructor(
      public contIdCdContestacao: number,
      public permNrSequencia :number,
      public contTxContestacao :string,
      public contDsArquivo :string,
      public contDsNomeArquivo :string,
      
      public usuaIdCdUsuario :number,
      public contDhRegistro :string,
      public contestationAnswers :BeanContestationAnswer[]=[],
      public userContestacao : BeanUsuario,
      public contInProcedente: string
      
    ){}
  }